export default __webpack_public_path__ + "a1c193952c1acd69a59ee927eb743e67.wav";